module.exports = __webpack_public_path__ + "media/images/flags/16/Northern-Cyprus-b78d450b54f8c95c30faa622bee3da35.png";